export const GET_PUBLIC_BRANDS = 'GET_PUBLIC_BRANDS';
export const GET_PUBLIC_BRANDS_SUCCESS = 'GET_PUBLIC_BRANDS_SUCCESS';
export const GET_PUBLIC_BRANDS_FAILURE = 'GET_PUBLIC_BRANDS_FAILURE';
